
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createProcurement } from '@/services/procurement/mutationService';
import type { CreateProcurementInput } from '@/types/database.types';

export const useCreateProcurement = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data: CreateProcurementInput) => {
      return createProcurement(data);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['procurements'] });
      if (data.harvest_id) {
        queryClient.invalidateQueries({ queryKey: ['procurements', data.harvest_id] });
      }
    }
  });
};
